module.exports = __webpack_public_path__ + "static/media/w (30).fb5d2e0d.jpg";